





























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { SitePerms, PermGroup, SitePerm, siteAdminPermApis, adminType, InternalSite } from '../../api';
import PermGroupEditDialog from './PermGroupEditDialog.vue';
import PermEditDialog from './PermEditDialog.vue';
import PermMembersDialog from '@/views/sites-admin/PermMembersDialog.vue';

@Component({ components: { PermGroupEditDialog, PermEditDialog, PermMembersDialog } })
export default class SitePermsTable extends Vue {
  @Prop({ required: true }) siteId!: number;
  @Prop({ required: true }) tabValue!: any;
  @Ref('perm-group-edit-dialog') groupEditDialog!: PermGroupEditDialog;
  @Ref('perm-edit-dialog') permEditDialog!: PermEditDialog;
  @Ref('perm-members-dialog') permMembersDialog!: PermMembersDialog;

  loading = true;
  perms: SitePerms = { groups: [] };
  data: any = [];

  watchParams() {
    return [this.siteId, this.tabValue];
  }

  mounted() {
    this.$watch(this.watchParams, this.refreshPerms);
    this.refreshPerms();
  }

  async refreshPerms() {
    if (this.tabValue == 'perm') {
      this.loading = true;
      this.perms = { groups: [] };
      this.data = [];
      try {
        this.perms = await siteAdminPermApis.getSitePerms(this.siteId);
        this.data = this.perms.groups.map(this._buildGroupData);
      } finally {
        this.loading = false;
      }
    }
  }

  _buildGroupData(group: PermGroup): any {
    let children: any = [];
    if (group.perms) {
      children = group.perms.map(p => this._buildPermData(group, p));
    }
    return {
      id: `group-${group.id}`,
      group,
      name: group.name,
      children
    };
  }

  _buildPermData(group: PermGroup, perm: SitePerm): any {
    return {
      id: `perm-${perm.id}`,
      name: perm.name,
      parent: group,
      perm: perm
    };
  }

  editGroup(group: PermGroup | null) {
    return this.groupEditDialog.show(group).then(this.refreshPerms);
  }

  async deleteGroup(group: PermGroup) {
    if (group.id) {
      await siteAdminPermApis.deletePermGroup(this.siteId, group.id);
    }
    const idx = this.perms.groups.indexOf(group);
    if (idx >= 0) {
      this.perms.groups.splice(idx, 1);
      this.data.splice(idx, 1);
    }
    this.$notify.success(`删除分组[${group.name}]成功`);
  }

  async editPerm(groupId: number | null, perm: SitePerm | null) {
    const newPerm = await this.permEditDialog.show(groupId, perm);
    let groupIdx = this.perms.groups.findIndex(g => g.id === groupId);
    if (groupIdx < 0 && this.perms.groups.length == 0) {
      this.perms.groups.push({ id: 0, name: '未分组权限', perms: [] });
      this.data.push(this._buildGroupData(this.perms.groups[0]));
      groupIdx = 0;
    }
    if (groupIdx >= 0) {
      const group = this.perms.groups[groupIdx];
      const idx = group.perms.findIndex(p => p.id === newPerm.id);
      if (idx >= 0) {
        group.perms[idx] = newPerm;
        Vue.set(this.data[groupIdx].children, idx, this._buildPermData(group, newPerm));
      } else {
        group.perms.push(newPerm);
        this.data[groupIdx].children.push(this._buildPermData(group, newPerm));
      }
      this.$notify.success(`权限[${newPerm.title}]保存成功`);
    }
  }

  async deletePerm(groupId: number | null, perm: SitePerm) {
    await siteAdminPermApis.deletePerm(this.siteId, perm.id);
    const groupIdx = this.perms.groups.findIndex(g => g.id === groupId);
    if (groupIdx >= 0) {
      const idx = this.perms.groups[groupIdx].perms.findIndex(p => p.id === perm.id);
      if (idx >= 0) {
        this.perms.groups[groupIdx].perms.splice(idx, 1);
        this.data[groupIdx].children.splice(idx, 1);
      }
    }
    this.$notify.success(`权限[${perm.title}]删除成功`);
  }

  showPermMembers(perm: SitePerm) {
    this.permMembersDialog.show(perm);
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }
}
